var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('finance-info', {
    attrs: {
      "detail": _vm.detail,
      "country": "Singapore"
    }
  }), _c('shareholders-info', {
    staticClass: "mt40",
    attrs: {
      "companyMemberList": _vm.detail.companyMemberList,
      "businessType": _vm.detail.businessType
    }
  }), _c('extra-info', {
    attrs: {
      "detail": _vm.detail,
      "nativeRegisteredAddress": _vm.nativeRegisteredAddress,
      "country": "Singapore"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }